import { onCLS, onINP, onFCP, onLCP, onTTFB } from 'web-vitals';

/** Static imports avoid webpack "Critical dependency" dynamic import warnings (CI treats them as errors). */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry);
    onINP(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
